export default [
  {
    title: 'breadcrumb.assistant',
    route: 'list-assistant',
    icon: 'UserIcon',
    resource: 'assistant',
    action: 'read'
  }
];